<template>
  <a-modal
    :visible="props.visible"
    :title="title"
    :onCancel="handleCancel"
    :bodyStyle="{ padding: '0px' }"
    centered
    :width="subTypeStrategy === TypeStrategy.Email && typeOriginStrategy == TypeOriginStrategy.Filters ? '1200px' :
    (subTypeStrategy === TypeStrategy.Email ? '1100px' : '600px')"
  >
    <!--Aqui se debe tener un loading-->
    <CustomScrollbar height="550px" :auto="true" class="modal__body">
      <a-spin v-if="loading" />
      <template v-else>
        <component
          v-if="section"
          :is="section"
          :dataSource="dataSource"
          :strategyOrigin="strategyOrigin"
        ></component>
      </template>
    </CustomScrollbar>
    <template #footer>
      <a-row class="modal__footer" align="middle" justify="space-around">
        <a-button class="modal__footer-button" @click="handleCancel">Cerrar detalles</a-button>
      </a-row>
    </template>
  </a-modal>
</template>
<script lang="ts" setup>
import { computed, ref, watch, reactive } from "vue";
import SectionStrategyTemplateDetails from "@/app/strategies/components/sections/SectionStrategyTemplateDetails.vue";
import SectionStrategyWhatsappDetails from "@/app/strategies/components/sections/SectionStrategyWhatsappDetails.vue";
import SectionStrategyEmailDetails from "@/app/strategies/components/sections/SectionStrategyEmailDetails.vue";
import SectionStrategyFiltersDetails from "@/app/strategies/components/sections/SectionStrategyFiltersDetails.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { fetchStrategy } from "@/app/strategies/services";
import { TypeOriginStrategy, TypeStrategy } from "@/@types/strategies/modalStrategy";

const props = defineProps({
  visible: {
    type: Boolean,
    required: false,
    default: false,
  },
  strategyId: {
    type: Number,
    required: true,
  },
  strategyOrigin: {
    type: Number,
    required: true,
  },
  strategyName: {
    type: String,
    required: true,
  },
});

const emits = defineEmits(["onClose"]);

const loading = ref(false);
const typeOriginStrategy = ref<TypeOriginStrategy>();
const subTypeStrategy = ref<TypeStrategy>();
let dataSource = reactive({});

const section = computed(() => {
  console.log(props.strategyOrigin, "strategyOrigin");
  switch (typeOriginStrategy.value) {
    case TypeOriginStrategy.Templates: {
      // verifica que el subtipo sea de whatsapp
      if (subTypeStrategy.value === TypeStrategy.Whatsapp) return SectionStrategyWhatsappDetails;
      if (subTypeStrategy.value === TypeStrategy.Email) return SectionStrategyEmailDetails;
      else return SectionStrategyTemplateDetails;
    }
    case TypeOriginStrategy.Filters:
      return SectionStrategyFiltersDetails;
    default:
      return null;
  }
});

watch(
  () => props.strategyId,
  () => loadInitialData()
);

const title = computed(() => {
  return props.strategyName ? `Ver detalles de "${props.strategyName}"` : "Ver detalles";
});

const loadInitialData = async () => {
  if (!props.strategyId) return;
  loading.value = true;
  const response = await fetchStrategy(props.strategyId);
  loading.value = false;
  typeOriginStrategy.value = props.strategyOrigin;
  subTypeStrategy.value = response.type_strategy;
  dataSource = response;
  console.log(dataSource, "dataSource");
  console.log(typeOriginStrategy, "typeOriginStrategy");
  console.log(subTypeStrategy, "subTypeStrategy");
};

const handleCancel = () => {
  emits("onClose");
};
</script>
<style lang="sass">
.modal
  &__body
    padding: 16px 14px
  &__footer
    width: 100%
  &__footer-button
    width: 210px
</style>
